import { CreditCard, Stethoscope } from 'lucide-react';
import { PLAN_TYPE_LABELS } from 'components/Profile/Insurance/helper';

export const FORM_ID = 'confirm-appointment-form';

export const PRIMARY_BTN = 'btn btn-neutral h-11 min-h-11 rounded-xl text-sm text-white';
export const SECONDARY_BTN = 'btn h-11 min-h-11 rounded-xl border-secondary-200 bg-white text-sm text-secondary-700 hover:border-secondary-300 hover:bg-secondary-50';

export const PENDING_BADGE =
  'inline-flex items-center gap-1 rounded-md bg-amber-100 px-1.5 py-0.5 text-[10px] font-bold uppercase tracking-wider text-amber-700';

export const SECTION_KEY = {
  personal: 'personal_information',
  medical: 'medical_history',
  insurance: 'insurance_intake',
};

export const NOTHING_ON_FILE = 'Nothing on file yet';

const countLabel = (group, singular, plural) => {
  const count = group?.data?.filter(({ attributes }) => attributes.status).length ?? 0;
  return count ? `${count} ${count === 1 ? singular : plural}` : '';
};

export const medicalHeadline = (attributes) => {
  if (!attributes) return NOTHING_ON_FILE;
  if (attributes.have_no_medical_conditions) return 'No allergies or conditions';

  const parts = [
    countLabel(attributes.allergies, 'allergy', 'allergies'),
    countLabel(attributes.conditions, 'condition', 'conditions'),
    countLabel(attributes.medications, 'medication', 'medications'),
  ].filter(Boolean);

  if (!parts.length) return attributes.medical_notes ? 'Notes on file' : NOTHING_ON_FILE;

  return parts.length === 1 ? `${parts[0]} on file` : parts.join(' · ');
};

export const insuranceHeadline = (attributes) => {
  if (!attributes) return NOTHING_ON_FILE;
  if (!attributes.active) return 'Self-pay — no insurance';

  const plan = [
    attributes.insurance_company?.data?.attributes?.title,
    PLAN_TYPE_LABELS[attributes.plan_type],
  ].filter(Boolean).join(' ');

  if (plan) return plan;

  return attributes.card_front_pic || attributes.card_back_pic ? 'Card photo on file' : NOTHING_ON_FILE;
};

export const getUpdateCards = ({ medical, insurance }) => [
  {
    id: 'medical',
    label: 'Medical',
    icon: Stethoscope,
    iconClass: 'bg-success-50 text-success-600',
    headline: medicalHeadline(medical)
  },
  {
    id: 'insurance',
    label: 'Insurance',
    icon: CreditCard,
    iconClass: 'bg-blue-50 text-blue-500',
    headline: insuranceHeadline(insurance),
    logo: insurance?.active ? insurance?.insurance_company?.data?.attributes?.logo_url : '',
  },
];
